import React from 'react'
import { BetInfo } from '@core/Areas/KambiSports/Components/BetHistory/BetInfo'
import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'
import { isKambiSharedCoupon } from '@core/Areas/BetLoop/helpers/typeGuards/isKambiSharedCoupon'
import { BetSelectionContainer } from '../Common/BetSelectionContainer'

export const KambiBetSelectionDisplay: React.FC<{
  sharedBet: BetLoopSharedBet
}> = ({ sharedBet }) => {
  if (!isKambiSharedCoupon(sharedBet.ticket)) return null

  return (
    <BetSelectionContainer.Container displayStatus={null}>
      <BetSelectionContainer.Inner>
        <BetInfo historyCoupon={sharedBet.ticket} />
      </BetSelectionContainer.Inner>
    </BetSelectionContainer.Container>
  )
}
